import axios from 'axios';
import { API_VERSION, VERIFY_TOKEN_ENDPOINT, GET_PAYMENT_RATE_ENDPOINT, GET_GCASH_ACCOUNT_LISTS_ENDPOINT, GET_CASHOUT_LISTS_ENDPOINT, CASHOUT_REGISTER_ENDPOINT, GCASH_ADD_TRANSACTION, CASHOUT_HISTORY_ENDPOINT, GIFCODE_CLAIM_ENDPOINT, REWARD_INFO, REWARD_FRIENDS, REWARD_HISTORY, REWARD_HISTORY_INFO } from './endpoints';

const send = (token, _data, url) => {
    let data = JSON.stringify(_data);
    let config = {
        method: 'post',
        url: url,
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        data: data
    };
    return axios(config);
}

export const verifyToken = (access_token, appInfo, _url) => {
    const url = `${_url}${VERIFY_TOKEN_ENDPOINT}${API_VERSION}`
    return send(access_token, {}, url);
}

export const getPayRate = (access_token, channels, appInfo, _url) => {
    const url = `${_url}${GET_PAYMENT_RATE_ENDPOINT}${API_VERSION}`
    return send(access_token, { channels }, url);
}

export const getGcashAccountLists = (access_token, vip, ref, appInfo, _url) => {
    const url = `${_url}${GET_GCASH_ACCOUNT_LISTS_ENDPOINT}${API_VERSION}`
    return send(access_token, { vip, ref }, url);
}

export const gcashAddTransaction = (access_token, tid, appInfo, _url) => {
    const url = `${_url}${GCASH_ADD_TRANSACTION}${API_VERSION}`
    return send(access_token, { tid }, url);
}

export const getCashoutLists = (access_token, appInfo, _url) => {
    const url = `${_url}${GET_CASHOUT_LISTS_ENDPOINT}${API_VERSION}`
    return send(access_token, { appid: appInfo.appid }, url);
}

export const cashoutRegister = (access_token, price, gid, source, appInfo, _url) => {
    const url = `${_url}${CASHOUT_REGISTER_ENDPOINT}${API_VERSION}`
    return send(access_token, { price, gid, source }, url);
}

export const getCashoutHistory = (access_token, appInfo, _url) => {
    const url = `${_url}${CASHOUT_HISTORY_ENDPOINT}${API_VERSION}`
    return send(access_token, {}, url);
}

export const giftCodeClaim = (access_token, code, _url) => {
    const url = `${_url}${GIFCODE_CLAIM_ENDPOINT}${API_VERSION}`
    return send(access_token, { code }, url);
}

export const getRewardInfo = (access_token, _url)  => {
    const url = `${_url}${REWARD_INFO}${API_VERSION}`
    return send(access_token, {}, url)
}


export const getRewardFriends = (access_token, _url) => {
    const url = `${_url}${REWARD_FRIENDS}${API_VERSION}`
    return send(access_token, {}, url)
}

export const getRewardHistory = (access_token, _url) => {
    const url = `${_url}${REWARD_HISTORY}${API_VERSION}`
    return send(access_token, {}, url)
}

export const getRewardHistoryInfo = (access_token, _url) => {
    const url = `${_url}${REWARD_HISTORY_INFO}${API_VERSION}`
    return send(access_token, {}, url)
}
